export function EyeIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='18' height='14' viewBox='0 0 18 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M11.4998 6.99996C11.4998 8.38067 10.3805 9.49996 8.9998 9.49996C7.61908 9.49996 6.4998 8.38067 6.4998 6.99996C6.4998 5.61925 7.61908 4.49996 8.9998 4.49996C10.3805 4.49996 11.4998 5.61925 11.4998 6.99996Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.04834 6.99993C2.11023 3.61902 5.2688 1.16663 9.00016 1.16663C12.7315 1.16663 15.8901 3.61905 16.952 6.99999C15.8901 10.3809 12.7315 12.8333 9.00018 12.8333C5.2688 12.8333 2.11022 10.3809 1.04834 6.99993Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
